import { defineMessages } from 'react-intl';

export const messages: {
    appTilesAlt: {
        defaultMessage: string;
        description: string;
        id: string;
    }; closeLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; heading: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subheadingConfluence: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subheadingJira: {
        defaultMessage: string;
        description: string;
        id: string;
    }; tryNowButton: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	heading: {
		id: 'twc.sample.banner.heading',
		defaultMessage: 'Ready to explore your entire collection?',
		description: 'Main heading text for the sample banner',
	},
	subheadingJira: {
		id: 'twc.sample.banner.subheadingJira',
		defaultMessage: 'Discover how the other apps can accelerate your workflows in Jira',
		description: 'Subheading text for the sample banner showcasing Jira',
	},
	subheadingConfluence: {
		id: 'twc.sample.banner.subheadingConfluence',
		defaultMessage: 'Discover how the other apps can accelerate your workflows in Confluence',
		description: 'Subheading text for the sample banner showcasing Confluence',
	},
	tryNowButton: {
		id: 'twc.sample.banner.try.now.button',
		defaultMessage: 'Try now',
		description: 'Text for the try now button in the sample banner',
	},
	closeLabel: {
		id: 'twc.sample.banner.close.label',
		defaultMessage: 'Close',
		description: 'Label for the close button in the sample banner',
	},
	appTilesAlt: {
		id: 'twc.sample.banner.app.tiles.alt',
		defaultMessage: 'App tiles illustration',
		description: 'Alt text for the app tiles illustration',
	},
});
